"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _classnames = _interopRequireDefault(require("classnames"));
var _TableModule = _interopRequireDefault(require("./Table.module.css"));
var _excluded = ["keys", "headings", "data", "direction", "variant", "borderless", "bordered", "striped", "roundedCorners", "roundedRows", "className", "children"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Table = function Table(_ref) {
  var keys = _ref.keys,
    headings = _ref.headings,
    data = _ref.data,
    direction = _ref.direction,
    variant = _ref.variant,
    borderless = _ref.borderless,
    bordered = _ref.bordered,
    striped = _ref.striped,
    roundedCorners = _ref.roundedCorners,
    roundedRows = _ref.roundedRows,
    className = _ref.className,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Table, _extends({
    className: (0, _classnames.default)(_TableModule.default.table, _TableModule.default[variant], className, striped && _TableModule.default.striped, roundedCorners && _TableModule.default.roundedCorners, roundedRows && _TableModule.default.roundedRows),
    borderless: borderless,
    bordered: bordered
  }, props), children ? children : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, direction === 'vertical' && /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, keys.map(function (key) {
    return /*#__PURE__*/_react.default.createElement("th", {
      key: key
    }, headings[key]);
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, direction === 'vertical' ? data.map(function (row, index) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: index
    }, keys.map(function (key) {
      return /*#__PURE__*/_react.default.createElement("td", {
        key: key
      }, row[key]);
    }));
  }) : keys.map(function (key) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: key
    }, /*#__PURE__*/_react.default.createElement("th", null, headings[key]), data.map(function (row, index) {
      return /*#__PURE__*/_react.default.createElement("td", {
        key: index
      }, row[key]);
    }));
  }))));
};
exports.Table = Table;
Table.propTypes = {
  keys: _propTypes.default.array,
  headings: _propTypes.default.object,
  data: _propTypes.default.array,
  direction: _propTypes.default.oneOf(['vertical', 'horizontal']),
  variant: _propTypes.default.oneOf(['primary', 'secondary']),
  borderless: _propTypes.default.bool,
  bordered: _propTypes.default.bool,
  striped: _propTypes.default.bool,
  roundedCorners: _propTypes.default.bool,
  roundedRows: _propTypes.default.bool
};
Table.defaultProps = {
  keys: ['index', 'firstName', 'lastName'],
  headings: {
    index: '#',
    firstName: 'First Name',
    lastName: 'Last Name'
  },
  data: [{
    index: /*#__PURE__*/_react.default.createElement("span", {
      "data-variant": "primary"
    }, "1"),
    firstName: 'Mark',
    lastName: 'Otto'
  }, {
    index: /*#__PURE__*/_react.default.createElement("span", {
      "data-variant": "secondary"
    }, "2"),
    firstName: 'Jacob',
    lastName: 'Thornton'
  }, {
    index: /*#__PURE__*/_react.default.createElement("span", {
      "data-variant": "accent"
    }, "3"),
    firstName: 'Mark',
    lastName: 'Otto'
  }, {
    index: 4,
    firstName: 'Jacob',
    lastName: 'Thornton'
  }],
  direction: 'vertical',
  variant: 'primary',
  borderless: true,
  bordered: false,
  striped: false,
  roundedCorners: false,
  roundedRows: false
};